import { LocalizedDateFromUtc, TooltippedTag } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { lt } from '@mews/framework';
import { IconName, Tag, Typography } from '@optimus-web/core';
import { ReservationUploadedContractFileSignatureStatus } from '@mews-commander/data-access';
import { ExpirationDaysLeftText } from '../ExpirationDaysLeftText';
import { useExpirationDaysLeftCount } from '../hooks/useExpirationDaysLeftCount';

interface SignatureStatusCellProps {
    status?: ReservationUploadedContractFileSignatureStatus;
    signatureDate?: string;
    signatureDeadlineDate?: string | null;
}

export const EXPIRATION_DAYS_LEFT_LIMIT = 5;

export const SignatureStatusTag = ({ status, signatureDate, signatureDeadlineDate }: SignatureStatusCellProps) => {
    const expirationDaysLeftCount = useExpirationDaysLeftCount(signatureDeadlineDate);

    switch (status) {
        case ReservationUploadedContractFileSignatureStatus.Signed:
            return (
                <>
                    <Tag variant="success" leadingIcon={IconName.CheckCircle}>
                        {lt('ContractSignatureStatusSignedLabel')}
                    </Tag>
                    <Typography textStyle="bodyExtraSmall" as="div" variant="secondary">
                        {UnicodeEntity.NoBreakSpace}
                        {signatureDate != null && <LocalizedDateFromUtc utcString={signatureDate} />}
                    </Typography>
                </>
            );
        case ReservationUploadedContractFileSignatureStatus.Pending:
            return expirationDaysLeftCount != null && expirationDaysLeftCount < EXPIRATION_DAYS_LEFT_LIMIT ? (
                <TooltippedTag
                    variant="warning"
                    leadingIcon={IconName.Hourglass}
                    trailingIcon={IconName.ErrorCircle}
                    tooltip={<ExpirationDaysLeftText expirationDate={signatureDeadlineDate} />}
                >
                    {lt('ContractSignatureStatusPendingLabel')}
                    {UnicodeEntity.NoBreakSpace}
                </TooltippedTag>
            ) : (
                <Tag variant="warning" leadingIcon={IconName.Hourglass}>
                    {lt('ContractSignatureStatusPendingLabel')}
                    {UnicodeEntity.NoBreakSpace}
                </Tag>
            );

        case ReservationUploadedContractFileSignatureStatus.Overdue:
            return (
                <TooltippedTag
                    variant="danger"
                    leadingIcon={IconName.Disable}
                    tooltip={lt('ContractSignatureStatusOverdueTooltip')}
                >
                    {lt('ContractSignatureStatusOverdueLabel')}
                </TooltippedTag>
            );
        default:
            return null;
    }
};
